import Endpoint from './endpoint'
import { API_URL } from './index'

export default class Stages extends Endpoint {
  async all(campaignId) {
    let url = new URL('/api/stages', API_URL)

    if (campaignId) {
      url.searchParams.set('campaign_id', campaignId)
    }

    return this.request(url)
  }

  async one(id) {
    let url = new URL(`/api/stages/${id}`, API_URL)

    return this.request(url)
  }

  async save(stage) {
    let url = new URL(`/api/stages/${'_id' in stage ? stage._id : ''}`, API_URL)

    return this.request(url, {
      method: '_id' in stage ? 'PUT' : 'POST',
      body: JSON.stringify(stage)
    })
  }

  async delete(stageId) {
    let url = new URL(`api/stages/${stageId}`, API_URL)

    return this.request(url, {
      method: 'DELETE'
    })
  }

  async move(stageId, afterId) {
    let url = new URL(`api/stages/${stageId}/move/${afterId}`, API_URL)

    return this.request(url, {
      method: 'PUT'
    })
  }

  async sendEmail(stageId, subjectOverride, bodyOverride, resourceType, resourceId) {
    let url = new URL(`/api/stages/${stageId}/send_mail/`, API_URL)

    // we are scoping to a single application or contact
    if (resourceType && resourceId) {
      url.searchParams.set('resource_type', resourceType)
      url.searchParams.set('resource_id', resourceId)
    }

    return this.request(url, {
      method: 'POST',
      body: JSON.stringify({
        subject: subjectOverride,
        body: bodyOverride
      })
    })
  }
}
